import { HMSRoomProvider } from "@100mslive/react-sdk";
import { ChatContextProvider } from "../ChatContextProvider";
import "../../index.css";
const AppWrapper = ({ config, children }: any) => {
  return (
    <HMSRoomProvider>
      <ChatContextProvider config={config}>{children}</ChatContextProvider>
    </HMSRoomProvider>
  );
};

export default AppWrapper;
